module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [(_vm.showHeaderAndFooter) ? _c('navbar') : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.showHeaderAndFooter) ? _c('bottom') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14249d18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1387
// module chunks = 1